import React, { useState } from "react";
import { featuresSelectors } from "../../redux/features/selectors/featuresSelectors.ts";
import { useAppSelector } from "../../redux/hooks.ts";
import { AnalysisModule } from "../analysis/AnalysisModule.tsx";
import { Flex } from "@aloft/toolkit-sui";
import { useTkv2ReferenceBarEvents } from "../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts";
import { selectHasArvOption } from "../../redux/features/selectors/orderSelectors.ts";
import { AppraisifyAnalysisToolbar } from "./components/AppraisifyAnalysisToolbar.tsx";
import { ViewMode } from "./types.ts";
import { AppraisifyAnalysisGrid } from "./components/AppraisifyAnalysisGrid.tsx";

import './AppraisifyAnalysisModule.scss';

export const AppraisifyAnalysisModule = React.memo(() => {
  const [viewMode, setViewMode] = useState<ViewMode>('simple');
  const { selectShouldShowNewCostApproachPage } = featuresSelectors;

  const shouldShowNewCostApproachPage = useAppSelector(selectShouldShowNewCostApproachPage);
  const hasArvOption = useAppSelector(selectHasArvOption);

  if (!shouldShowNewCostApproachPage) {
    return <AnalysisModule />
  }

  return (
    <Flex
      {...useTkv2ReferenceBarEvents()}
      className="appraisify-analysis-module"
      width="100%"
      gap={hasArvOption ? 0 : 2}
      paddingLeft="1.5rem"
    >
      <AppraisifyAnalysisToolbar viewMode={viewMode} setViewMode={setViewMode} />
      <AppraisifyAnalysisGrid viewMode={viewMode} />
    </Flex>
  )
});
